import { Container, Flex, Text } from '@chakra-ui/react';
import { TimeIcon } from '@chakra-ui/icons'
import { Autocomplete } from 'components';
import { useGetCities } from 'hooks';

type DestinationFilterProps = {
    onChange: (values: any) => void;
    placeholder: string;
};

const RECENT_SEARCHES =[
    {
        name: 'Tullum',
        date: '22-31 Aug'
    },
    {
        name: 'Roman',
        date: '22-31 Aug'
    },
    {
        name: 'Madrid',
        date: '22-31 Aug'
    },
    {
        name: 'Chico',
        date: '22-31 Aug'
    }
];

const DestinationFilter = ({onChange, placeholder}: DestinationFilterProps) => {
    const { data: responseData } = useGetCities();
    const mappedResponse = responseData?.data.map((city: { id: any; cityName: any; }) => ({value: city.id, label: city.cityName}));
    return <Container padding={10} width={800} height="fit-content">
    <Autocomplete placeholder={placeholder} onChange={() => { } } onInputChange={() =>{}} options={mappedResponse || []}/>
       <Flex direction="row" justifyContent="flex-start">
        <Flex direction="column" paddingRight={24}>
            <Text fontFamily="Montserrat" fontWeight={600} fontSize={15} paddingBottom="40px">Recent searches</Text>
            {RECENT_SEARCHES.map((search, index) => 
                <Flex direction="row" key={index} justifyContent="space-between">
                    <Flex width={50} height={50} justifyContent="center" alignItems="center" borderRadius="50%" boxShadow="0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)">
                        <TimeIcon />
                    </Flex>
                    <Flex direction="column" justifyContent="flex-start" marginBottom="20px">
                        <Text fontFamily="Montserrat" fontWeight={400} fontSize={15}>{search.name}</Text>
                        <Text color="#6F6F6F" fontFamily="Montserrat" fontWeight={400} fontSize={11}>{search.date}</Text>
                    </Flex>
                </Flex>
            )}
        </Flex>
       </Flex>
    </Container>
}

export {DestinationFilter};